//import React, { useEffect, useState } from "react";
import React, { useState } from "react";
//import { useParams } from "react-router-dom";
import "../../Styles/form.css";

const JobDetails = () => {
  // const { id } = useParams();
  // const [jobData, setJobData] = useState(null);
  // const [loading, setLoading] = useState(true);
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    // Job_Role: "",
    Full_Name: "",
    Email: "",
    PhoneNumber: "",
    subject: "",
    Message: "",
    Resume: null,
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData((prev) => ({ ...prev, [name]: files[0] }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    Object.keys(formData).forEach((key) => {
      payload.append(key, formData[key]);
    });

    try {
      const API_BASE = "/ann/ann-ai-cms/public/";
      const res = await fetch(
        API_BASE + "api/submitpost",
        {
          method: "POST",
          body: payload,
        }
      );

      if (!res.ok) {
        throw new Error("Failed to submit form");
      }

      setSuccessMessage("✅ Your application has been submitted successfully!");
      // Reset form
      setFormData({
        // Job_Role: jobData?.job_title || "",
        Full_Name: "",
        Email: "",
        PhoneNumber: "",
        subject: "",
        Message: "",
        Resume: null,
      });
    } catch (err) {
      console.error(err);
      setSuccessMessage("❌ Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="form-card">
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          <div className="form-row">
            <div className="form-group">
              {" "}
              <label>Full Name *</label>
              <input
                type="text"
                name="Full_Name"
                value={formData.Full_Name}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group">
              <label>Email *</label>
              <input
                type="email"
                name="Email"
                value={formData.Email}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <br />
          <div className="form-row">
            <div className="form-group">
              <label>Phone</label>
              <input
                type="tel"
                name="PhoneNumber"
                value={formData.PhoneNumber}
                onChange={handleChange}
              />
            </div>
            <div className="form-group">
              <label>Subject *</label>
              <input
                type="text"
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <br />
          <div className="form-row">
            <div className="form-group">
              <label>Message *</label>
              <textarea
                name="Message"
                rows="5"
                value={formData.Message}
                onChange={handleChange}
                required
              ></textarea>
            </div>
          </div>
          <br />
          <div className="form-row">
            <div className="form-group">
              {" "}
              <label>Resume *</label>
              <input
                type="file"
                name="Resume"
                accept=".pdf,.doc,.docx"
                onChange={handleChange}
                required
              />
            </div>
          </div>
          <br />
          <div className="form-group">
            {" "}
            <button className="submit-btn" type="submit">
              SUBMIT →
            </button>
          </div>

          {/* Success message below button */}
          {successMessage && (
            <p
              style={{
                marginTop: "10px",
                color: successMessage.startsWith("✅") ? "green" : "red",
              }}
            >
              {successMessage}
            </p>
          )}
        </form>
      </div>
    </>
  );
};

export default JobDetails;
